{
  "INBOX_MGMT": {
    "HEADER": "Innhólf",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Tengja aftur",
      "FACEBOOK": "Tengingin við Facebook rann út eða var afturkölluð. Skilaboð til síðunnar berast ekki í þetta innhólf og svör geta mistekist. Einstaklingur sem stjórnar Facebook-síðunni þarf að smella á Tengja aftur og skrá sig inn á Facebook.",
      "INSTAGRAM": "Tengingin við Instagram rann út eða var afturkölluð. Skilaboð til reikningsins berast ekki í þetta innhólf og svör geta mistekist. Smelltu á Tengja aftur og skráðu þig inn á sama Instagram-reikning. Annar reikningur býr til nýtt innhólf.",
      "GOOGLE": "Tengingin við Google rann út eða var afturkölluð. Nýr tölvupóstur berst ekki í þetta innhólf og svör geta mistekist. Smelltu á Tengja aftur og skráðu þig inn á Google sem {email}.",
      "MICROSOFT": "Tengingin við Microsoft rann út eða var afturkölluð. Nýr tölvupóstur berst ekki í þetta innhólf og svör geta mistekist. Smelltu á Tengja aftur og skráðu þig inn á Microsoft sem {email}.",
      "ALLEGRO": "Tengingin við Allegro rann út eða var afturkölluð. Skilaboð frá kaupendum berast ekki í þetta innhólf og svör geta mistekist. Smelltu á Tengja aftur og skráðu þig inn á Allegro sem seljandinn {seller}. Annar seljandareikningur býr til nýtt innhólf.",
      "IMAP_LOGIN": "Póstþjónninn hafnar IMAP-innskráningunni {login}. Nýr tölvupóstur berst ekki í þetta pósthólf. Athugaðu IMAP-notandanafn og lykilorð á flipanum {tab} og vistaðu þau. Við höldum áfram að reyna að skrá inn og pósthólfið jafnar sig um leið og innskráning tekst.",
      "WHATSAPP": "Tengingin við WhatsApp er útrunnin eða var afturkölluð. Viðhengi frá viðskiptavinum berast ekki í þetta innhólf og svör geta mistekist. Smelltu á Tengja aftur, skráðu þig inn á Facebook og veldu númerið {phone} aftur."
    },
    "LIST": {
      "404": "Það eru engin innhólf tengd við þennan reikning.",
      "RECONNECT_REQUIRED": "Tengja þarf aftur"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Veldu rás",
        "BODY": "Veldu þjónustuveituna sem þú vilt samþætta við spjallið."
      },
      "INBOX": {
        "TITLE": "Nýtt innhólf",
        "BODY": "Staðfestu reikninginn þinn og búðu til pósthólf."
      },
      "AGENT": {
        "TITLE": "Bæta við þjónustufulltrúa",
        "BODY": "Bæta þjónustufulltrúum á nýja innhólfið."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Þú ert tilbúin til að halda áfram!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nafn Innhólfs",
        "PLACEHOLDER": "Sláðu inn nafn innhólfsins (Dæmi: Acme ehf)",
        "ERROR": "Vinsamlegast sláðu inn gilt nafn innhólfs"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nafn Vefsíðu",
        "PLACEHOLDER": "Sláðu inn nafn vefsíðu (Dæmi: Acme ehf)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Innra nafn",
        "PLACEHOLDER": "Gefðu innhólfinu nafn eins og það birtist í þessu stjórnborði",
        "ERROR": "Vinsamlegast sláðu inn einkvæmt innra nafn"
      },
      "FB": {
        "HELP": "PS: Með því að skrá þig inn fáum við aðeins aðgang að skilaboðum síðunnar þinnar. Við getum aldrei nálgast einkaskilaboðin þín.",
        "CHOOSE_PAGE": "Veldu Síðu",
        "CHOOSE_PLACEHOLDER": "Veldu síðu úr listanum",
        "INBOX_NAME": "Nafn Innhólfs",
        "ADD_NAME": "Bættu við nafni á innhólfið",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Veldu gildi",
        "CREATE_INBOX": "Skrá innhólf"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Halda áfram með Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Tengdu Instagram aðganginn þinn",
        "HELP": "Til að bæta Instagram aðgangnum þínum við sem rás þarftu að auðkenna Instagram aðganginn þinn með því að smella á „Halda áfram með Instagram“",
        "ERROR_MESSAGE": "Villa kom upp við tengingu við Instagram, vinsamlegast reyndu aftur",
        "ERROR_AUTH": "Villa kom upp við tengingu við Instagram, vinsamlegast reyndu aftur",
        "NEW_INBOX_SUGGESTION": "Þessi Instagram aðgangur var áður tengdur öðru innhólfi og hefur nú verið fluttur hingað. Öll ný skilaboð birtast hér framvegis. Gamla innhólfið getur ekki lengur sent eða tekið á móti skilaboðum fyrir þennan aðgang.",
        "DUPLICATE_INBOX_BANNER": "Þessi Instagram aðgangur var fluttur í nýja Instagram rásar innhólfið. Þú getur ekki lengur sent eða tekið á móti Instagram skilaboðum úr þessu innhólfi."
      },
      "TWITTER": {
        "HELP": "Til að bæta Twitter prófílnum þínum við sem rás þarftu að auðkenna Twitter prófílinn þinn með því að smella á 'Skráðu þig inn með Twitter'",
        "ERROR_MESSAGE": "Villa kom upp við að tengjast Twitter, vinsamlegast reyndu aftur",
        "TWEETS": {
          "ENABLE": "Búðu til samtöl úr merktum Tweet-um"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Vefsíðu rás",
        "DESC": "Búðu til rás fyrir vefsíðuna þína og byrjaðu að aðstoða viðskiptavini þína í gegnum netspjallið okkar.",
        "LOADING_MESSAGE": "Búa til Vefsíðu Þjónustu Rás",
        "CHANNEL_AVATAR": {
          "LABEL": "Rásamynd"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Vefkróks URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Vinsamlega skráðu gilt URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Lén Vefsíðu",
          "PLACEHOLDER": "Sláðu lénið á vefsíðunni þinni (dæmi: acme.is)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Móttöku Fyrirsögn",
          "PLACEHOLDER": "Hæ!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Móttöku taglína",
          "PLACEHOLDER": "Við gerum það einfalt að tengjast okkur. Spyrðu okkur hvað sem er eða deildu þínu áliti."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Móttökuskilaboð rásar",
          "PLACEHOLDER": "Acme Inc svarar iðulega innan nokkura klukkustunda."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Virkja móttöku skilaboð",
          "HELP_TEXT": "Sendu sjálfkrafa kveðjuskilaboð þegar nýtt samtal er búið til.",
          "ENABLED": "Virkt",
          "DISABLED": "Slökkt"
        },
        "REPLY_TIME": {
          "TITLE": "Skrá Svartíma",
          "IN_A_FEW_MINUTES": "Eftir örfáar mínútur",
          "IN_A_FEW_HOURS": "Eftir nokkrar klukkustundir",
          "IN_A_DAY": "Eftir sólarhring",
          "HELP_TEXT": "Þessi svartími mun birtast á netspjallinu"
        },
        "WIDGET_COLOR": {
          "LABEL": "Litur Widgets",
          "PLACEHOLDER": "Uppfæra litinn notaðan í widgetinu"
        },
        "SUBMIT_BUTTON": "Skrá innhólf",
        "API": {
          "ERROR_MESSAGE": "Við gátum ekki búið til vefsíðurás, vinsamlegast reyndu aftur"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Rás",
        "DESC": "Innleiddu Twilio og byrjaðu að aðstoða viðskiptavini þína með SMS eða WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "SID Aðgangs",
          "PLACEHOLDER": "Vinsamlegast sláðu inn SID á Twilio Aðganginum þínum",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID Skilaboðaþjónustu",
          "PLACEHOLDER": "Vinsamlegast sláðu inn Twilio Messaging Service SID",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit",
          "USE_MESSAGING_SERVICE": "Nota Twilio Skilaboðaþjónustuna"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Tegund Rásar",
          "ERROR": "Vinsamlegast veldu tegund rásar"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auðkenningar token",
          "PLACEHOLDER": "Please enter your Twilio Auth Token",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nafn Innhólfs",
          "PLACEHOLDER": "Vinsamlegast sláðu inn nafn innhólfs",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
        },
        "PHONE_NUMBER": {
          "LABEL": "Símanúmer",
          "PLACEHOLDER": "Vinsamlega sláðu inn símanúmerið sem skilaboð verða send frá.",
          "ERROR": "Vinsamlegast sláðu inn gilt símanúmer sem byrjar með ´+´ merki og inniheldur ekki nein bil."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Þú verður að stilla afturhringingarslóð skilaboða í Twilio með slóðinni sem nefnd er hér."
        },
        "SUBMIT_BUTTON": "Skrá Twilio Rás",
        "API": {
          "ERROR_MESSAGE": "Við gátum ekki auðkennt Twilio auðkenni, vinsamlegast reyndu aftur"
        }
      },
      "SMS": {
        "TITLE": "SMS Rás",
        "DESC": "Byrjaðu að aðstoða viðskiptavinina þína í gegnum SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandbreidd",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Það tókst ekki að skrá SMS rásina"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Reikningsnúmer",
            "PLACEHOLDER": "Please enter your Bandwidth Account ID",
            "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
          },
          "API_KEY": {
            "LABEL": "API Lykill",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "Vinsamlegast sláðu inn Bandwidth Application ID",
            "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
          },
          "INBOX_NAME": {
            "LABEL": "Nafn Innhólfs",
            "PLACEHOLDER": "Vinsamlegast sláðu inn nafn innhólfs",
            "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
          },
          "PHONE_NUMBER": {
            "LABEL": "Símanúmer",
            "PLACEHOLDER": "Vinsamlega sláðu inn símanúmerið sem skilaboð verða send frá.",
            "ERROR": "Vinsamlegast sláðu inn gilt símanúmer sem byrjar með ´+´ merki og inniheldur ekki nein bil."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "Við gátum ekki auðkennt Bandwidth auðkenni, vinsamlegast reyndu aftur"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "Þú verður að stilla afturhringingarslóð skilaboða í Bandwidth með slóðinni sem nefnd er hér."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Nafn Innhólfs",
            "PLACEHOLDER": "Vinsamlegast sláðu inn nafn innhólfs",
            "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
          },
          "PHONE_NUMBER": {
            "LABEL": "Símanúmer",
            "PLACEHOLDER": "Vinsamlega sláðu inn símanúmerið sem skilaboð verða send frá.",
            "ERROR": "Vinsamlegast sláðu inn gilt símanúmer sem byrjar með ´+´ merki."
          },
          "SUBMIT_BUTTON": "Skrá SMS Brana Rás",
          "API": {
            "ERROR_MESSAGE": "Við gátum ekki búið til SMS Brana rásina"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Nafn Innhólfs",
            "PLACEHOLDER": "Vinsamlegast sláðu inn nafn innhólfs",
            "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
          },
          "PHONE_NUMBER": {
            "LABEL": "Símanúmer",
            "PLACEHOLDER": "Vinsamlega sláðu inn símanúmerið sem skilaboð verða send frá.",
            "ERROR": "Vinsamlegast sláðu inn gilt símanúmer sem byrjar með ´+´ merki."
          },
          "SUBMIT_BUTTON": "Skrá DIDWW Rás",
          "API": {
            "ERROR_MESSAGE": "Við gátum ekki búið til DIDWW rásina"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Þú verður að stilla vefkrók (e. webhook) slóðina og staðfestingarígildið (e. verification token) í Facebook Developer Portal með gildunum sem sýnd eru hér að neðan.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Fljótleg uppsetning með Meta",
          "DESC": "Þér verður vísað á Meta til að skrá þig inn á WhatsApp Business aðganginn þinn. Aðgangur sem stjórnandi gerir uppsetninguna einfaldari og áreynslulausari.",
          "BENEFITS": {
            "EASY_SETUP": "Engin handvirk uppsetning nauðsynleg",
            "SECURE_AUTH": "Örugg OAuth auðkenning",
            "AUTO_CONFIG": "Sjálfvirk uppsetning á webhook og símanúmeri"
          },
          "SUBMIT_BUTTON": "Tengja við WhatsApp Business",
          "AUTH_PROCESSING": "Auðkennir með Meta",
          "WAITING_FOR_BUSINESS_INFO": "Vinsamlegast kláraðu uppsetningu fyrirtækisins í Meta glugganum...",
          "PROCESSING": "Setur upp WhatsApp Business aðganginn þinn",
          "CANCELLED": "Hætt var við WhatsApp skráningu",
          "WAITING_FOR_AUTH": "Bíður eftir auðkenningu...",
          "INVALID_BUSINESS_DATA": "Ógildar fyrirtækjaupplýsingar bárust frá Facebook. Vinsamlegast reyndu aftur.",
          "SIGNUP_ERROR": "Villa kom upp við skráningu",
          "SDK_LOAD_ERROR": "Ekki tókst að hlaða Facebook SDK. Reyndu aftur.",
          "AUTH_NOT_COMPLETED": "Auðkenningu var ekki lokið. Vinsamlegast byrjaðu ferlið upp á nýtt.",
          "SUCCESS_FALLBACK": "WhatsApp Business aðgangurinn hefur verið settur upp",
          "RECONNECTED": "WhatsApp-rásin var tengd aftur"
        },
        "API": {
          "ERROR_MESSAGE": "Við gátum ekki vistað WhatsApp rásina"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Channel",
        "DESC": "Samþættu við API rásina og byrjaðu að þjónusta viðskiptavini þína.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "URL Vefkróks"
        },
        "SUBMIT_BUTTON": "Skrá API Rás",
        "API": {
          "ERROR_MESSAGE": "Það tókst ekki að vista api rásina"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce rás",
        "DESC": "Samþættu við Salesforce rásina og byrjaðu að þjónusta viðskiptavini þína.",
        "CHANNEL_NAME": {
          "LABEL": "Nafn Rásar",
          "PLACEHOLDER": "Vinsamlegast sláðu inn nafn rásar",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API slóð",
          "SUBTITLE": "Stilltu grunnslóð fyrir Salesforce umhverfið þitt.",
          "PLACEHOLDER": "Slóð Salesforce API"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Key ID fyrir Salesforce rásina þína.",
          "PLACEHOLDER": "KEY ID"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Secret fyrir Salesforce rásina þína.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Skrá Salesforce Rás",
        "API": {
          "ERROR_MESSAGE": "Við gátum ekki vistað Salesforce rásina"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook URL",
          "SUBTITLE": "Þú verður að stilla webhook slóðina í Salesforce með slóðinni sem nefnd er hér."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Notaðu þetta bearer token til auðkenningar þegar þú stillir webhook í Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Yfirskrifa sendanda tölvupósts",
          "SUBTITLE": "Ef þetta er stillt verður þetta tölvupóstfang notað sem sendandi allra útsendra tölvupósta í stað upprunatölvupósts samtalsins.",
          "PLACEHOLDER": "t.d. stod{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro Rás",
        "DESC": "Tengdu Allegro söluaðgang og svaraðu skilaboðamiðstöð hans úr þjónustuverinu.",
        "CHANNEL_NAME": {
          "LABEL": "Nafn Innhólfs",
          "SUBTITLE": "Nafnið sem þjónustufulltrúar sjá fyrir þetta innhólf.",
          "PLACEHOLDER": "Sláðu inn nafn innhólfs",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
        },
        "SUBMIT_BUTTON": "Skráðu þig inn með Allegro",
        "API": {
          "ERROR_MESSAGE": "Villa kom upp við tengingu við Allegro, vinsamlegast reyndu aftur"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro innskráning",
          "SUBTITLE": "Söluaðgangurinn sem þetta innhólf les og svarar skilaboðum fyrir."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland Rás",
        "DESC": "Svaraðu skilaboðunum sem kaupendur senda þér á Kaufland markaðstorginu.",
        "CHANNEL_NAME": {
          "LABEL": "Nafn Rásar",
          "PLACEHOLDER": "Vinsamlegast sláðu inn nafn rásar",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "32 stafa Client Key af API stillingasíðu Kaufland söluaðgangsins þíns.",
          "PLACEHOLDER": "32 stafa lykill",
          "ERROR": "Sláðu inn 32 stafa Client Key"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "64 stafa Secret Key sem tilheyrir Client Key. Kaufland sýnir hann einu sinni og hann er aldrei sendur aftur á þessa síðu.",
          "PLACEHOLDER": "64 stafa lykill",
          "ERROR": "Sláðu inn 64 stafa Secret Key"
        },
        "SUBMIT_BUTTON": "Skrá Kaufland Rás",
        "API": {
          "ERROR_MESSAGE": "Við gátum ekki vistað Kaufland rásina"
        },
        "DISCONNECTED": {
          "TITLE": "Aftengt",
          "MESSAGE": "Kaufland hafnaði þessum API lyklum. Sláðu inn Client Key og Secret Key aftur til að tengja þetta innhólf á ný."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Tölvupóst Rás",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Nafn Rásar",
          "PLACEHOLDER": "Vinsamlegast sláðu inn nafn rásar",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
        },
        "EMAIL": {
          "LABEL": "Netfang",
          "SUBTITLE": "Tölvupóstur þar sem viðskiptavinir þínir senda þér þjónustubeiðnir",
          "PLACEHOLDER": "Netfang"
        },
        "SUBMIT_BUTTON": "Skrá Tölvupóst Rás",
        "API": {
          "ERROR_MESSAGE": "Við gátum ekki vistað tölvupóstrásina"
        },
        "FINISH_MESSAGE": "Byrja að áframsenda tölvupóstinn þinn á eftirfarandi netfang."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Rás",
        "DESC": "Samþættu við LINE rásina og byrjaðu að þjónusta viðskiptavini þína.",
        "CHANNEL_NAME": {
          "LABEL": "Nafn Rásar",
          "PLACEHOLDER": "Vinsamlegast sláðu inn nafn rásar",
          "ERROR": "Það er nauðsynlegt að fylla út þennan reit"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "Einkennisnúmer LINE Rásar",
          "PLACEHOLDER": "Einkennisnúmer LINE Rásar"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Leyndarmál LINE Rásar",
          "PLACEHOLDER": "Leyndarmál LINE Rásar"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token LINE Rásar",
          "PLACEHOLDER": "Token LINE Rásar"
        },
        "SUBMIT_BUTTON": "Skrá LINE Rás",
        "API": {
          "ERROR_MESSAGE": "Við gátum ekki vistað LINE rásina"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Þú verður að stilla webhook slóðina í LINE forritinu með slóðinni sem nefnd er hér."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Rás",
        "DESC": "Samþættu við Telegram rásina og byrjaðu að þjónusta viðskiptavini þína.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Stilltu bot token sem þú hefur fengið frá Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Skrá Telegram Rás",
        "API": {
          "ERROR_MESSAGE": "Við gátum ekki vistað Telegram rásina"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Símtöl",
        "DESC": "Stilltu hvaða símtöl birtast í þessu innhólfi.",
        "NAME": {
          "LABEL": "Nafn Innhólfs",
          "SUBTITLE": "Veldu auðþekkjanlegt nafn."
        },
        "PHONE_NUMBER": {
          "LABEL": "Símanúmer",
          "SUBTITLE": "Sláðu inn símanúmer sem tilheyra þessu innhólfi, þú getur bætt við fleiri númerum síðar.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Skrá símtala innhólf",
        "API": {
          "ERROR_MESSAGE": "Við gátum ekki búið til innhólfið"
        }
      },
      "AUTH": {
        "TITLE": "Veldu rás",
        "DESC": "Spjallið styður vefspjall, Facebook Messenger, WhatsApp, tölvupóst osfrv. sem rásir. Ef þú vilt búa til sérsniðna rás geturðu búið hana til með því að nota API rásina. Til að byrja skaltu velja eina af rásunum hér að neðan."
      },
      "AGENTS": {
        "TITLE": "Þjónustufulltrúar",
        "DESC": "Hér geturðu bætt við þjónustufulltrúum til að hafa umsjón með nýstofnuða innhólfinu þínu. Aðeins þessir völdu Þjónustufulltrúar munu hafa aðgang að innhólfinu þínu. Þjónustufulltrúar sem eru ekki hluti af þessu innhólfi munu ekki geta séð eða svarað skilaboðum í þessu innhólfi þegar þeir skrá sig inn. <br> <b>PS:</b> Sem stjórnandi, ef þú þarft aðgang að öllum pósthólfum, ættir þú að bæta sjálfum þér sem þjónustufulltrúa við öll innhólf sem þú býrð til.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Veldu þjónustufulltrúa fyrir innhólfið"
      },
      "DETAILS": {
        "TITLE": "Innhólfs Upplýsingar",
        "DESC": "Í fellilistanum hér að neðan, veldu Facebook síðuna sem þú vilt tengja við spjallið. Þú getur líka gefið innhólfinu sérsniðið nafn til að þekkja það betur."
      },
      "FINISH": {
        "TITLE": "Nailed It!",
        "DESC": "Þú hefur lokið við að tengja Facebook síðuna þína við spjallið. Næst þegar viðskiptavinur sendir skilaboð á síðunni þinni birtist samtalið sjálfkrafa í innhólfinu þínu.<br>Við erum líka að útvega þér netspjalls skriftu sem þú getur auðveldlega bætt við vefsíðuna þína. Þegar þetta er komið á vefsvæðið þitt geta viðskiptavinir sent þér skilaboð beint frá vefsíðunni þinni án hjálpar utanaðkomandi tóla og samtalið mun birtast hér, í spjallinu.<br>Svalt, ha? Jæja, við reynum að vera það :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Auðkenni við Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Eitthvað fór úrskeiðis, vinsamlegast endurnýjaðu síðuna...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Við gátum ekki búið til innhólfið. Vinsamlegast reyndu aftur.",
      "CREATING_CHANNEL": "Skrái innhólfið...",
      "TITLE": "Stilla Upplýsingar Innhólfs",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Bæta við þjónustufulltrúum",
      "ADD_AGENTS": "Er að bæta þjónustufulltrúum á innhólfið..."
    },
    "FINISH": {
      "TITLE": "Innhólfið þitt er tilbúið!",
      "MESSAGE": "Þú getur nú átt samskipti við viðskiptavini þína í gegnum nýju rásina þína. Gangi þér vel við þjónustuna",
      "BUTTON_TEXT": "Taktu mig þangað",
      "MORE_SETTINGS": "Fleiri stillingar",
      "WEBSITE_SUCCESS": "Þú hefur lokið við að búa til vefsíðurás. Afritaðu kóðann sem sýndur er hér að neðan og límdu hann á vefsíðuna þína. Næst þegar viðskiptavinur notar spjallið birtist samtalið sjálfkrafa í innhólfinu þínu."
    },
    "REAUTH": "Endurauðkenna",
    "VIEW": "Skoða",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Stillingar innhólfs voru uppfærðar",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Sjálfvirkum skráningum var breytt",
        "ERROR_MESSAGE": "Við gátum ekki uppfært stillingar innhólfs. Vinsamlegast reyndu aftur síðar."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Virkt",
        "DISABLED": "Slökkt"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Virkt",
        "DISABLED": "Slökkt"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Virkt",
        "DISABLED": "Óvirkt"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "frá",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Virkt",
        "DISABLED": "Slökkt"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Virkt",
        "DISABLED": "Slökkt"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Ekkert"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Virkt",
        "DISABLED": "Slökkt"
      },
      "ENABLE_HMAC": {
        "LABEL": "Virkja"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Virkt",
        "DISABLED": "Slökkt"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Virkt",
        "DISABLED": "Slökkt"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Virkja samstillingu innkomandi tölvupósta"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Virkja sérsniðið tölvupóstlén (greidd þjónusta)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Virkja vinnslu Facebook athugasemda"
      },
      "SIGNATURE": {
        "TITLE": "HTML Undirskrift",
        "SUB_TEXT": "Þessi undirskrift verður bætt neðst í öll skilaboð sem send eru úr þessu innhólfi.",
        "HTML_CONTENT": "HTML kóði",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} verður skipt út fyrir nafn þjónustufulltrúans.\n{'{{'}email{'}}'} verður skipt út fyrir tölvupóstfang þjónustufulltrúans sem sendi tölvupóstinn.\n{'{{'}position{'}}'} verður skipt út fyrir stöðu þjónustufulltrúans.\n{'{{'}custom_line{'}}'} verður skipt út fyrir sérsniðnu línu þjónustufulltrúans.\n{'{{'}email_signature_picture{'}}'} verður skipt út fyrir slóð á undirskriftarmynd þjónustufulltrúans (ekki myndtag) — notaðu hana sem myndagjafa (src í img tagi).",
        "PREVIEW": "Forskoðun"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Undirskriftir eftir löndum",
        "SUB_TEXT": "Svar fær undirskrift eftir landi kaupandans.",
        "HELP": "Svar er undirritað eftir landi samtalsins: eftir Kaufland-versluninni, markaðstorgi Allegro-pöntunarinnar eða annars eftir tungumáli kaupandans. Ef landið er óþekkt eða engin undirskrift er skilgreind fyrir það hér er HTML undirskriftin hér að ofan notuð. Markaðstorg banna tengla á vefsíðuna þína og tengiliðaupplýsingar, svo hafðu aðeins kveðju og {'{{'}name{'}}'}.",
        "EMPTY": "Þú hefur engar undirskriftir fyrir lönd ennþá, þannig að svör nota HTML undirskriftina hér að ofan.",
        "COUNTRY": "Veldu land",
        "ADD": "Bæta við undirskrift fyrir land",
        "REMOVE": "Fjarlægja"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Forskeyti fyrir símanúmer",
        "PLACEHOLDER": "Sláðu inn forskeyti fyrir rétta símtalsbeiningu (t.d. *99)",
        "HELP_TEXT": "Þessu forskeyti verður sjálfkrafa bætt framan við símanúmer tengiliða þegar hringt er úr þessu innhólfi."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Texti hnapps fyrir „leysum síðar“",
        "PLACEHOLDER": "t.d. Við leysum þetta málefni með tölvupósti. Ég vil spyrja um eitthvað annað núna.",
        "HELP_TEXT": "Texti hnappsins í spjallglugganum sem gerir gestinum kleift að yfirgefa núverandi málefni og spyrja um eitthvað annað. Skildu reitinn eftir auðan til að nota sjálfgefinn texta á tungumáli gestsins."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Blunda ósvöruðum símtölum sjálfkrafa í X mínútur",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Blunda ósvöruðum símtölum sjálfkrafa í tiltekinn fjölda mínútna. Skildu eftir autt eða settu 0 til að slökkva á þessu."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Leysa ósvarað símtal eftir X misheppnaðar tilraunir til að hringja til baka",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Þegar búið er að hringja X sinnum til baka í ósvarað símtal án þess að viðskiptavinurinn svari er það leyst sjálfkrafa og einkaathugasemd bætt við. Skildu eftir autt eða settu 0 til að slökkva á þessu."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Spurningatillögur",
        "SUB_TEXT": "Stilltu fyrirfram skilgreindar spurningar sem viðskiptavinir geta notað til að eiga samskipti við þjónustufulltrúa þína.",
        "QUESTIONS_LABEL": "Spurningar",
        "ADD_QUESTION": "Bæta við spurningu",
        "REMOVE": "Fjarlægja",
        "QUESTION_TEXT": "Texti sem birtist í blöðrunni.",
        "QUESTION_TEXT_PLACEHOLDER": "Nauðsynlegt",
        "QUESTION_PAYLOAD": "Texti sem er sendur þegar smellt er á.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Valfrjálst",
        "NO_BOT_MESSAGE": "Til að fá fleiri AI tillögur skaltu tengja botta.",
        "BOT_CONNECTED_MESSAGE": "AI spurningatillögur frá botanum má virkja í",
        "BOT_SETTINGS_LINK": "stillingum hans"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Aðrir tölvupóstar",
        "SUB_TEXT": "Viðbótarnetföng sem þetta pósthólf ætti að meðhöndla sem sín eigin þegar áframsendur póstur berst.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Bæta við",
        "REMOVE": "Fjarlægja",
        "EMPTY": "Engir aðrir tölvupóstar stilltir.",
        "HELP_TEXT": "Þegar tölvupóstur berst með eitt af þessum netföngum sem viðtakanda verða svör send með sama netfangi sem sendanda. Gakktu úr skugga um að útsendingar-SMTP-þjónninn þinn leyfi sendingu frá þessum netföngum.",
        "SIGNATURE_LABEL": "Undirskrift",
        "PRIMARY_SIGNATURE": "Aðal (sjálfgefið)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Fleiri undirskriftir",
        "SUB_TEXT": "Skilgreindu fleiri undirskriftir hér og úthlutaðu þeim svo á aðra tölvupósta hér að neðan.",
        "OPTION": "Undirskrift {number}",
        "ADD": "Bæta við undirskrift",
        "REMOVE": "Fjarlægja",
        "HELP_TEXT": "Þegar svar er sent frá öðru tölvupóstfangi er úthlutaða undirskriftin notuð í stað undirskriftar pósthólfsins. Önnur tölvupóstföng sem eru skilin eftir á „Aðal (sjálfgefið)“ nota undirskrift pósthólfsins."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Eyða",
      "AVATAR_DELETE_BUTTON_TEXT": "Eyða mynd",
      "DELETE_REQUESTED_TOOLTIP": "Þetta innhólf er merkt til eyðingar",
      "RESTORE_BUTTON_TEXT": "Endurheimta",
      "CONFIRM": {
        "TITLE": "Staðfesta eyðingu",
        "MESSAGE": "Ertu viss um að þú viljir eyða",
        "PLACE_HOLDER": "Vinsamlegast sláðu inn {inboxName} til að staðfesta",
        "YES": "Já, eyða",
        "NO": "Nei, hætta við eyðingu"
      },
      "API": {
        "SUCCESS_MESSAGE": "Innhólfi eytt",
        "MARKED_FOR_DELETION_MESSAGE": "Innhólf merkt til eyðingar",
        "RESTORE_SUCCESS_MESSAGE": "Tókst að endurheimta innhólfið",
        "ERROR_MESSAGE": "Gat ekki eytt innhólfi. Vinsamlegast reyndu aftur síðar.",
        "RESTORE_ERROR_MESSAGE": "Ekki tókst að endurheimta innhólfið. Vinsamlegast reyndu aftur síðar.",
        "AVATAR_SUCCESS_MESSAGE": "Mynd eytt",
        "AVATAR_ERROR_MESSAGE": "Gat ekki eytt notandamynd innhólfsins. Vinsamlegast reyndu aftur síðar."
      }
    },
    "TABS": {
      "SETTINGS": "Stillingar",
      "COLLABORATORS": "Samstarfsaðilar",
      "AUTOMATIC_PRIORITY": "Sjálfvirkur forgangur",
      "AUTOMATIC_LABELING": "Sjálfvirk merking",
      "CONFIGURATION": "Stillingar",
      "CAMPAIGN": "Herferð",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Business Hours",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot stillingar",
      "SLA": "SLA"
    },
    "SETTINGS": "Stillingar",
    "FEATURES": {
      "LABEL": "Fídusar",
      "DISPLAY_FILE_PICKER": "Display file picker on the widget",
      "DISPLAY_EMOJI_PICKER": "Display emoji picker on the widget",
      "ALLOW_END_CONVERSATION": "Leyfa notendum að ljúka samtali úr græjunni",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Sýna hnappinn 'Hefja nýtt samtal' í haus viðmótshlutans",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Sýna hnappinn 'Flytja til þjónustufulltrúa' í haus viðmótshlutans",
      "AUTO_CLOSE_OLD": "Merkja öll fyrri símtöl frá sama númeri sem leyst þegar eitt þeirra er leyst.",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Úthluta sjálfkrafa ósvöruðum símtölum þegar hringt er út.",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Leyfa þjónustufulltrúum að senda skilaboð þegar tengiliður er ótengdur og ekki er hægt að halda samtalinu áfram með tölvupósti."
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Script",
      "MESSENGER_SUB_HEAD": "Place this button inside your body tag",
      "INBOX_AGENTS": "Þjónustufulltrúar",
      "INBOX_TEAMS": "Teymi",
      "INBOX_COOPERATORS": "Samstarfsaðilar",
      "SELECT_PLACEHOLDER": "Veldu",
      "AGENTS_OR_TEAMS_INFO": "Þú getur úthlutað annaðhvort þjónustufulltrúum eða teymum - ekki bæði samtímis.",
      "INBOX_AGENTS_SUB_TEXT": "Add or remove agents from this inbox",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "Uppfæra",
      "ENABLE_EMAIL_COLLECT_BOX": "Enable email collect box",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Virkja eða slökkva á söfnunarreit tölvupósts í nýju samtali",
      "AUTO_ASSIGNMENT": "Enable auto assignment",
      "ENABLE_CSAT": "Enable CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Virkja CSAT fyrir hver skilaboð",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Virkja/slökkva á CSAT (ánægju viðskiptavina) könnun eftir að hafa leyst samtal",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Virkja/slökkva á CSAT könnun fyrir hver skilaboð sem þjónustufulltrúar senda",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Samtöl halda áfram með tölvupósti ef tengiliðanetfangið er tiltækt.",
      "RESPOND_FROM_EMAIL": "Svara frá tölvupósti",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Tölvupóstar til viðskiptavinarins — bæði svör og afrit af samtölum — eru sendir með SMTP-stillingum valda tölvupóstinnhólfsins, frá völdu netfangi (eigin netfangi innhólfsins eða einu af samnefnum þess), og svör viðskiptavinarins berast til baka í gegnum IMAP-netfang þess.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Afrit af samtölum eru send með SMTP-stillingum valda tölvupóstinnhólfsins, frá völdu netfangi (eigin netfangi innhólfsins eða einu af samnefnum þess), og svör berast til baka í gegnum IMAP-netfang þess.",
      "SHOW_WELCOME_SCREEN": "Sýna móttökuskjá",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Sýna móttökuskjá þegar widget-ið er opnað. Ef slökkt er á þessu fer widget-ið beint í samtalsskjáinn.",
      "AUTO_CLOSE_PENDING": "Leysa AI spjöll sjálfkrafa eftir (klukkustundir)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Leysa AI spjöll sjálfkrafa eftir X klukkustunda aðgerðaleysi.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Kveikja eða slökkva á samtíma samtölum fyrir sama tengilið í þessu innhólfi",
      "INBOX_UPDATE_TITLE": "Inbox Settings",
      "INBOX_UPDATE_SUB_TEXT": "Update your inbox settings",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Virkja eða slökkva á sjálfvirkri úthlutun nýrra samtöla til umboðsmanna sem bætt er við þetta innhólf.",
      "HMAC_VERIFICATION": "User Identity Validation",
      "HMAC_DESCRIPTION": "Til að sannreyna auðkenni notandans geturðu sent `identifier_hash` fyrir hvern notanda. Þú getur búið til HMAC sha256 hash með því að nota 'identifier' með lyklinum sem sýndur er hér.",
      "HMAC_ROTATE": {
        "BUTTON": "Skipta um lykil",
        "TITLE": "Skipta um leynilykil?",
        "WARNING": "Núverandi lykill er ógiltur um leið og honum er skipt út.",
        "WARNING_DETAIL": "Enginn skörunartími er í boði og ekki er hægt að endurheimta hann.",
        "IMPACT": "Netþjónar þínir verða að undirrita notendur með nýja lyklinum. Allir sem enn eru undirritaðir með gamla lyklinum falla á auðkenningu. Ef auðkenningar er krafist geta þeir ekki hafið samtal.",
        "CONFIRM": "Skipta um lykil",
        "CANCEL": "Hætta við",
        "SUCCESS": "Tókst að skipta um leynilykil",
        "ERROR": "Ekki tókst að skipta um leynilykil, reyndu aftur"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Enforce User Identity Validation",
      "HMAC_MANDATORY_DESCRIPTION": "Ef það er virkt verður beiðnum sem vantar ‘identifier_hash’ hafnað.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Þvinga nýtt samtal við hverja hleðslu á widget",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Ef virkt hefst nýtt samtal þegar widget er opnað í nýjum flipa eða glugga.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Gleyma tengilið þegar nýtt samtal er hafið",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Ef óvirkt er heldur nýtt samtal sem hafið er úr widget-inu áfram með fyrri tengilið.",
      "INBOX_IDENTIFIER": "Inbox Identifier",
      "INBOX_IDENTIFIER_SUB_TEXT": "Notaðu `inbox_identifier` táknið sem sýnt er hér til að auðkenna API biðlara.",
      "FORWARD_EMAIL_TITLE": "Forward to Email",
      "FORWARD_EMAIL_SUB_TEXT": "Byrja að áframsenda tölvupóstinn þinn á eftirfarandi netfang.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Samstilling tölvupósts",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Virkja sjálfvirka samstillingu og niðurhal á móttekum tölvupósti úr þessu innhólfi",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Sérsniðið tölvupóstlén",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Virkja til að nota sérsniðið tölvupóstlén fyrir útsendan tölvupóst",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Þú getur lesið meira hér.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook-athugasemdir",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Leyfa skilaboð eftir að samtal hefur verið leyst",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Leyfa endanotendum að senda skilaboð jafnvel eftir að samtalið er leyst.",
      "WIDGET_STATUS_LABEL": "Staða widgets",
      "WIDGET_STATUS_ENABLED": "Virkt",
      "WIDGET_STATUS_BUSINESS_HOURS": "Virkt á opnunartíma",
      "WIDGET_STATUS_DISABLED": "Slökkt",
      "WIDGET_STATUS_HELP_TEXT": "Stjórnaðu hvenær widget-ið er sýnt gestum á vefsíðunni þinni",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "CSAT könnun og tungumál tölvupósts",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Veldu tungumálið fyrir öll tölvupóstsamskipti við viðskiptavini, þar á meðal CSAT kannanir, afrit af samtölum og tilkynningar í tölvupósti",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Erfa frá aðgangi",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp-tenging",
        "SUBTITLE": "Svona er þetta innhólf tengt WhatsApp.",
        "PROVIDER": "Þjónustuaðili",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Tengt með innbyggðri skráningu Meta",
        "STATUS": "Staða",
        "CONNECTED": "Tengt",
        "RECONNECT_HINT": "Smelltu á Tengja aftur í tilkynningunni hér að ofan.",
        "PHONE_NUMBER": "Símanúmer",
        "BUSINESS_ACCOUNT": "Auðkenni WhatsApp Business-reiknings",
        "OPEN_MANAGER": "Opna í WhatsApp Manager",
        "PHONE_NUMBER_ID": "Auðkenni símanúmers",
        "TEMPLATES": "Skilaboðasniðmát",
        "TEMPLATES_COUNT": "{approved} af {total} samþykkt",
        "TEMPLATES_SYNCED": "Síðast samstillt {date}",
        "TEMPLATES_NOT_SYNCED": "Ekki samstillt enn",
        "MANAGE_TEMPLATES": "Stjórna sniðmátum"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Please enter a value greater than 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Takmarkaðu hámarksfjölda samtala úr þessu innhólfi sem hægt er að úthluta sjálfkrafa á þjónustufulltrúa"
    },
    "SLA": {
      "TITLE": "SLA reglur",
      "SUB_TEXT": "Stilltu SLA svartíma og lausnartíma fyrir hvert forgangsstig samtala.",
      "LOADING": "Hleð inn SLA reglum...",
      "FIELDS": {
        "ACTIVE": "Virkt",
        "TICKET_PRIORITY": "Forgangur samtals",
        "FIRST_RESPONSE_TIME": "Fyrsti svartími",
        "EVERY_RESPONSE_TIME": "Sérhver svartími",
        "RESOLUTION_TIME": "Lausnartími",
        "PLACEHOLDER": "t.d. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "Tókst að uppfæra SLA reglur.",
        "ERROR_MESSAGE": "Ekki tókst að uppfæra SLA reglur. Vinsamlegast reyndu aftur."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Sjálfvirkur forgangur",
      "SUB_TEXT": "Stilltu sjálfvirka úthlutun forgangs út frá innihaldi samtals.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Tilkynning um gjaldtöku",
        "MESSAGE": "Sérhvert mat á forgangi hefur í för með sér gjald. Skoðaðu áskriftaráætlun þína fyrir verðupplýsingar."
      },
      "MODE": {
        "OFF": "Slökkt",
        "ALL_MESSAGES": "Virkt fyrir öll móttekin skilaboð",
        "FIRST_MESSAGE": "Virkt aðeins fyrir fyrstu móttekin skilaboð"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Stillingar forgangsstiga",
        "SUB_TEXT": "Stilltu hvaða forgangsstig eiga að vera virk og lýsingar þeirra. Gefðu skýr viðmið svo AI geti ákvarðað hvenær á að úthluta þessum forgangi."
      },
      "DESCRIPTION_LABEL": "Lýsing",
      "DESCRIPTION_PLACEHOLDER": "Lýstu samtölum sem á að merkja með {priority} forgangi",
      "SET_AS_DEFAULT": "Setja sem sjálfgefinn forgang",
      "MULTIPLE_DEFAULTS_WARNING": "Aðeins eitt forgangsstig má vera sjálfgefið. Vinsamlegast afhakaðu aðra sjálfgefna valkosti."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Sjálfvirk merking",
      "SUB_TEXT": "Stilltu sjálfvirka úthlutun merkinga út frá innihaldi samtals.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Tilkynning um gjaldtöku",
        "MESSAGE": "Sérhvert mat á merkingu hefur í för með sér gjald. Skoðaðu áskriftaráætlun þína fyrir verðupplýsingar."
      },
      "MODE": {
        "OFF": "Slökkt",
        "CONVERSATION_OPEN": "Virkt þegar samtal er opnað",
        "CONVERSATION_CLOSE": "Virkt þegar samtali er lokað",
        "ALL_MESSAGES": "Virkt fyrir öll skilaboð - óháð stöðu",
        "FIRST_MESSAGE": "Virkt fyrir fyrstu skilaboð - óháð stöðu"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Stillingar merkinga",
        "SUB_TEXT": "Stilltu hvaða merkingar eiga að vera í boði fyrir sjálfvirka úthlutun og lýsingar þeirra. Gefðu skýr viðmið svo AI geti ákvarðað hvenær á að nota þessa merkingu."
      },
      "DESCRIPTION_LABEL": "Lýsing",
      "DESCRIPTION_PLACEHOLDER": "Lýstu samtölum sem á að merkja með {label}. Ef þú lætur þetta autt verður notuð lýsing merkingarinnar.",
      "NO_LABELS_MESSAGE": "Engar merkingar fundust. Búðu fyrst til merkingar til að virkja sjálfvirka merkingu.",
      "CREATE_LABELS_LINK": "Búa til merkingar"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Endurauðkenna",
      "SUBTITLE": "Facebook tengingin þín er útrunnin, vinsamlegast tengdu Facebook síðuna þína aftur til að halda áfram þjónustu",
      "MESSAGE_SUCCESS": "Reconnection successful",
      "MESSAGE_ERROR": "There was an error, please try again"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Forspjallseyðublöð gera þér kleift að fanga notendaupplýsingar áður en þau hefja samtal við þig.",
      "SET_FIELDS": "Pre chat form fields",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Fields",
        "LABEL": "Label",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Key",
        "TYPE": "Type",
        "REQUIRED": "Nauðsynlegt"
      },
      "ENABLE": {
        "LABEL": "Enable pre chat form",
        "OPTIONS": {
          "ENABLED": "Já",
          "DISABLED": "Nei"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "Þessi skilaboð væru sýnileg notendum ásamt eyðublaðinu"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Gestir ættu að gefa upp nafn sitt og netfang áður en spjallið hefst"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Set your availability",
      "SUBTITLE": "Stilltu framboð þitt á netspjalli",
      "WEEKLY_TITLE": "Set your weekly hours",
      "TIMEZONE_LABEL": "Select timezone",
      "UPDATE": "Update business hours settings",
      "TOGGLE_AVAILABILITY": "Virkja opnunartíma fyrirtækja fyrir þetta innhólf",
      "UNAVAILABLE_MESSAGE_LABEL": "Unavailable message for visitors",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Enable availability for this day",
        "UNAVAILABLE": "Unavailable",
        "HOURS": "hours",
        "VALIDATION_ERROR": "Upphafstími ætti að vera fyrir lokunartíma.",
        "CHOOSE": "Velja"
      },
      "ALL_DAY": "Allan Daginn",
      "SAVE_TO_ALL": "Vista í öll innhólf",
      "SAVE_TO_ALL_TITLE": "Afrita opnunartíma",
      "SAVE_TO_ALL_CONFIRM": "Stillingarnar úr þessu eyðublaði (rofi fyrir framboð, skilaboð um fjarveru, tímabelti og opnunartímar) verða afritaðar í öll önnur innhólf nema tölvupósts- og símainnhólf. Ertu viss um að þú viljir halda áfram?",
      "SAVE_TO_ALL_CANCEL": "Hætta við",
      "SAVE_TO_ALL_YES": "Já, afrita í öll",
      "SAVE_TO_ALL_SUCCESS": "Tókst að afrita opnunartíma í öll önnur innhólf",
      "SAVE_TO_ALL_ERROR": "Ekki tókst að afrita opnunartíma í önnur innhólf"
    },
    "PHONE": {
      "TITLE": "Símastillingar",
      "SUBTITLE": "Stilltu hvaða símtöl birtast í þessu innhólfi.",
      "UPDATE": "Vista stillingar",
      "EDIT": {
        "SUCCESS_MESSAGE": "Símastillingum var breytt"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Símanúmer",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Skrá IMAP upplýsingar",
      "NOTE_TEXT": "Vinsamlegast tilltu IMAP til að virkja SMTP.",
      "UPDATE": "Uppfæra IMAP stilingar",
      "TOGGLE_AVAILABILITY": "Virkja IMAP stillingar fyrir þetta innhólf",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP stillingar voru uppfærðar",
        "ERROR_MESSAGE": "Tókst ekki að uppfæra IMAP stillingar"
      },
      "ADDRESS": {
        "LABEL": "Slóð",
        "PLACE_HOLDER": "Slóð (Dæmi: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Notandanafn",
        "PLACE_HOLDER": "Notandanafn"
      },
      "PASSWORD": {
        "LABEL": "Lykilorð",
        "PLACE_HOLDER": "Lykilorð"
      },
      "ENABLE_SSL": "Virkja SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Skrá SMTP upplýsingar",
      "UPDATE": "Uppfæra SMTP stillingar",
      "TOGGLE_AVAILABILITY": "Kveikja á SMTP stillingu fyrir þetta innhólf",
      "TOGGLE_HELP": "Að virkja SMTP mun hjálpa notandanum að senda tölvupóst",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP stillingum var breytt",
        "ERROR_MESSAGE": "Tókst ekki að uppfæra SMTP stillingar"
      },
      "ADDRESS": {
        "LABEL": "Slóð",
        "PLACE_HOLDER": "Slóð (Dæmi: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Notandanafn",
        "PLACE_HOLDER": "Notandanafn"
      },
      "PASSWORD": {
        "LABEL": "Lykilorð",
        "PLACE_HOLDER": "Lykilorð"
      },
      "DOMAIN": {
        "LABEL": "Lén",
        "PLACE_HOLDER": "Lén"
      },
      "ENCRYPTION": "Dulkóðun",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Opna SSL Sannreyningar Ham",
      "AUTH_MECHANISM": "Auðkenning"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Afhending tölvupósts (DNS)",
      "SUB_TITLE": "Við athugum SPF-, DKIM-, DMARC- og MX-færslur {domain} á hverjum virkum degi. Þegar eitthvað veldur því að móttökuþjónar hafna svörum ykkar eða færa þau í ruslpóst fá stjórnendur tölvupóst með lagfæringunni.",
      "RUN": "Keyra athugun",
      "RUN_SUCCESS": "DNS-athugun lokið",
      "RUN_ERROR": "Ekki tókst að keyra DNS-athugunina, vinsamlegast reynið aftur",
      "NOT_CHECKED": "Ekki enn athugað.",
      "CHECKED_AT": "Síðast athugað {time}.",
      "DNS_UNAVAILABLE": "Í síðustu athugun fékkst ekkert svar frá nafnaþjónum lénsins. Niðurstaðan hér að neðan er úr athuguninni á undan.",
      "SENDER": {
        "SMTP": "Svör eru send í gegnum {host}.",
        "PLATFORM": "Svör eru send í gegnum póstþjóna okkar."
      },
      "STATUS": {
        "OK": "Allar færslur eru í lagi",
        "WARNING": "Sumar færslur mætti bæta",
        "ERROR": "Svör gætu ekki borist viðtakendum",
        "UNKNOWN": "Óþekkt"
      },
      "SEVERITY": {
        "ERROR": "Vandamál",
        "WARNING": "Viðvörun"
      },
      "FIX": "Lagfærið þetta með þessari DNS-færslu:",
      "RECORD_TYPE": "Tegund",
      "RECORD_HOST": "Heiti",
      "RECORD_VALUE": "Gildi",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF-færsla vantar",
          "DESCRIPTION": "Lénið tilgreinir ekki hvaða þjónar mega senda tölvupóst fyrir það. Margir póstþjónar líta þá á svör ykkar sem ruslpóst. Bætið við SPF-færslu sem leyfir {sender}."
        },
        "spf_multiple": {
          "TITLE": "Lénið er með {count} SPF-færslur",
          "DESCRIPTION": "Lén má aðeins hafa eina SPF-færslu. Séu þær fleiri hunsa móttökuþjónar SPF og hafna oft póstinum. Sameinið þær í eina færslu."
        },
        "spf_not_authorized": {
          "TITLE": "SPF leyfir ekki þjóninn sem sendir svör ykkar",
          "DESCRIPTION": "Svör ykkar eru send í gegnum {sender} en SPF-færsla lénsins nefnir hann ekki. Núverandi færsla: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF-færslan krefst of margra DNS-uppflettinga",
          "DESCRIPTION": "Móttökuþjónar hætta að athuga SPF eftir {limit} DNS-uppflettingar en {sender}, sem sendir svör ykkar, kemur ekki að fyrr en eftir {lookups}. Svör ykkar falla á SPF. Færið {sender} fremst í færsluna og fjarlægið include-færslur sem lénið notar ekki lengur."
        },
        "spf_lookups_others": {
          "TITLE": "Sumir sendendur í SPF-færslunni eru handan uppflettimarkanna",
          "DESCRIPTION": "SPF-færslan krefst {lookups} DNS-uppflettinga en móttökuþjónar hætta eftir {limit}. Svör ykkar eru afgreidd í tæka tíð og standast prófið, en póstur frá þessum sendendum fellur á SPF: {senders}. Fjarlægið include-færslur sem lénið notar ekki lengur."
        },
        "spf_malformed": {
          "TITLE": "SPF-færslan er biluð",
          "DESCRIPTION": "Móttökuþjónar geta ekki lesið SPF-færslu lénsins og því ver hún ekki svör ykkar. Vandinn er í: {terms}. Skiptið færslunni út fyrir leiðrétta færslu."
        },
        "dkim_missing": {
          "TITLE": "DKIM-undirskrift er ekki uppsett",
          "DESCRIPTION": "Við fundum engan DKIM-lykil á {selectors}. Án hans eru svör ykkar ekki undirrituð og líklegri til að lenda í ruslpósti. Kveikið á DKIM-undirritun fyrir lénið hjá tölvupóstveitunni ykkar."
        },
        "dmarc_missing": {
          "TITLE": "DMARC-færsla vantar",
          "DESCRIPTION": "Stórar póstveitur á borð við Gmail og Microsoft ætlast til að til sé DMARC-færsla. Án hennar eru svör ykkar líklegri til að lenda í ruslpósti."
        },
        "dmarc_fails": {
          "TITLE": "DMARC skipar móttakendum að hafna svörum ykkar",
          "DESCRIPTION": "DMARC-stefna lénsins er „{policy}“ og svör ykkar standast hvorki SPF né DKIM, þannig að móttakendur hafna þeim eða færa þau í ruslpóst. Lagfærið SPF og DKIM hér að ofan."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC lokar á svör sem eru send í gegnum póstþjóna okkar",
          "DESCRIPTION": "Þetta pósthólf sendir svör í gegnum póstþjóna okkar, en DMARC-stefna lénsins er „{policy}“, þannig að móttakendur hafna þeim eða færa þau í ruslpóst. Setjið upp SMTP á ykkar eigin póstþjóni fyrir þetta pósthólf."
        },
        "mx_missing": {
          "TITLE": "Lénið hefur enga MX-færslu",
          "DESCRIPTION": "Án MX-færslu getur enginn sent tölvupóst á lénið og viðskiptavinir geta því ekki svarað svörum ykkar."
        }
      }
    },
    "NOTE": "Merkimiði: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Vefsíðumynd",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Vefsíðumynd eytt",
              "ERROR_MESSAGE": "Það kom upp villa, vinsamlegast reyndu aftur"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nafn Vefsíðu",
          "PLACE_HOLDER": "Sláðu inn nafn vefsíðu (Dæmi: Acme ehf)",
          "ERROR": "Vinsamlegast sláðu inn gilt vefsíðunafn"
        },
        "WELCOME_HEADING": {
          "LABEL": "Móttöku Fyrirsögn",
          "PLACE_HOLDER": "Hæ!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Móttöku taglína",
          "PLACE_HOLDER": "Við gerum það einfalt að tengjast okkur. Spyrðu okkur hvað sem er eða deildu þínu áliti."
        },
        "REPLY_TIME": {
          "LABEL": "Svartími",
          "IN_A_FEW_MINUTES": "Eftir örfáar mínútur",
          "IN_A_FEW_HOURS": "Eftir nokkrar klukkustundir",
          "IN_A_DAY": "Eftir sólarhring"
        },
        "WIDGET_COLOR_LABEL": "Litur Widgets",
        "WIDGET_BUBBLE_POSITION_LABEL": "Staðsetning Widget Blöðru",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Hámarkshæð ólesinna skilaboða (px)",
          "PLACE_HOLDER": "Engin takmörk",
          "HELP_TEXT": "Takmarkaðu hámarkshæð sprettiglugga fyrir ólesin skilaboð í pixlum. Skildu eftir autt fyrir sjálfgefna hegðun (engin takmörk)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Tegund Widget Blöðru",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Spjallaðu við okkur",
          "LABEL": "Titill Widget Blöðru",
          "PLACE_HOLDER": "Spjallaðu við okkur"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Uppfæra stillingar widgets",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Svarar iðulega innan nokkura mínútna",
        "IN_A_FEW_HOURS": "Svarar iðulega innan nokkura klukkustunda",
        "IN_A_DAY": "Svarar iðulega samdægurs"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Hefja samtal",
        "CHAT_INPUT_PLACEHOLDER": "Skrifaðu skilaboðin hér"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Við erum tengd",
          "OFFLINE": "Það er enginn við í augnablikinu"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hello"
      },
      "BRANDING_TEXT": "Keyrt af JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Website",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Tölvupóstfang",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Channel",
      "PHONE": "SIP sími",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
